import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {EntityHeader} from "../entity/entity-header";
import {EntitySearchCriteria} from "../entity/entity-search-criteria";
import {GoogleService} from "./google-service";
import { Service, inject } from "@angular/core";

@Service()
export class SelectParentEntityDialogService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public getList(criteria: EntitySearchCriteria): Observable<EntityHeader[]> {
    let url = this.urlBase + 'entity/list';
    let body = JSON.stringify(criteria);
    return this.http.post<EntityHeader[]>(url, body, {headers: this.getPostHeaders()});
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }
}
